import React from 'react';
import { useTranslation } from 'react-i18next';
import gateStyles from './AgentWidgetGate.module.css';

interface AgentWidgetGateLoadingProps {
  messageKey: 'agent:loading.connectingCxone' | 'agent:loading.initializing';
}

export function AgentWidgetGateLoading({ messageKey }: AgentWidgetGateLoadingProps) {
  const { t } = useTranslation();

  return (
    <div className={gateStyles.loadingContainer}>
      <div className={gateStyles.spinner} />
      <p className={gateStyles.loadingText}>{t(messageKey)}</p>
    </div>
  );
}
